"use client";

// Extend the global Window interface to include Branch
declare global {
    interface Window {
        branch: Branch;
    }
}

// Branch SDK interface
interface Branch {
    init: (key: string, options?: Record<string, unknown>, callback?: (err: unknown, data: unknown) => void) => void;
    setIdentity: (user: string | undefined) => void;
    logEvent: (eventName: string, customData: Record<string, unknown>) => void;
}

// Initialize Branch SDK
export const initBranch = async (): Promise<unknown> => {
    if (typeof window === "undefined" || !window.branch) {
        return Promise.resolve("Branch SDK not available");
    }

    if (String(process.env.APP_BRANCH_IO_ENABLED) !== "true") {
        return Promise.resolve("Branch SDK is disabled");
    }

    return new Promise((resolve, reject) => {
        window.branch.init(
            String(process.env.APP_BRANCH_IO_KEY),
            {},
            (err: unknown, data: unknown) => {
                if (err) {
                    console.error("Branch initialization error:", err);
                    reject(err);
                } else {
                    resolve(data);
                }
            }
        );
    });
};

// Track custom Branch event
export const trackEvent = async (
    eventName: string,
    email?: string,
    phone?: string,
    userId?: string,
    amount?: string,
    value?: string,
    milestoneName?: string
): Promise<void> => {
    if (typeof window === "undefined" || !window.branch) return;

    // Optional: Capture GCLID from URL if needed for Google Ads
    const gclid = typeof window !== "undefined"
        ? new URLSearchParams(window.location.search).get("gclid")
        : null;

    // Identify the user
    window.branch.setIdentity(userId || "");

    const customData: Record<string, unknown> = {
        server: process.env.API_BASE_URL,
        email: email || "",
        phone: phone || "",
        userId: userId || "",
        amount: amount || "",
        value: value || "",
        gclid: gclid || "",
        milestoneName: milestoneName || "",
        link_id: "DD8C1B30302A5851DF5FB7780B7786FB",
    };

    try {
        window.branch.logEvent(eventName, customData);
    } catch (error) {
        console.error("Error tracking Branch event:", error);
    }
};
